import { Component, OnInit } from '@angular/core';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { BmBrandService } from 'src/app/Services/admin-rights/bm-brand.service';
import { Bmbrandmapping, bmmapping } from 'src/app/Models/Admin/bmbrandmapping';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-brand-mapping',
  templateUrl: './brand-mapping.component.html',
  styleUrls: ['./brand-mapping.component.css']
})
export class BrandMappingComponent implements OnInit {
  loader: string = 'none';
  brandmanagers: any[];
  products: any[];
  bmproducts: any[];
  mappings: any[];
  dsGridColumn: any[];
  selectedRegionMessage: any[];
  bmbrandmapping: Bmbrandmapping[];

  form: FormGroup;
  checkbo: any;

  constructor(private snackBar: MatSnackBarComponent, private bmBrandService: BmBrandService, private router: Router, private formBuilder: FormBuilder,private toastr: ToastrService) {
    this.form = this.formBuilder.group({
      orders: new FormArray([])
    });
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
    this.getBrandList();
    this.bmbrandmapping = [];

  }

  getBrandList() {
    this.loader = 'block';
    this.bmBrandService.getBrandList()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.loader = 'none';
          this.mappings = resdata.data.mapping;
          this.bmproducts = resdata.data.bmproducts;
          this.brandmanagers = resdata.data.brandmanagers;
          this.products = resdata.data.products;
          this.dsGridColumn = this.getAllKeysFromList(this.mappings);

        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }

  getAllKeysFromList(data: any) {
    var response = data.reduce(function (arr, o) {
      return Object.keys(o).reduce(function (a, k) {
        if (a.indexOf(k) == -1) a.push(k);
        return a;
      }, arr)
    }, []);
    return response;
  }
  updateBmBrandMapping() {
    // for(let i = 0; i < this.bmbrandmapping.length; i++){
    //       for(let j = 0; j < this.bmproducts.length; j++){
    //         if(this.bmbrandmapping[i].Brand==this.bmproducts[j].brand && this.bmbrandmapping[i].IsActive ==true && this.bmproducts[j].isActive==true){
    //           if(this.bmbrandmapping[i].UserID!=this.bmproducts[j].brandManager){
    //             this.toastr.error('Select only one Brand Manager for a Brand','Close', 'red-snackbar');
    //             return false;
    //           }
    //           else{
    //             this.bmBrandService.updateBmBrandmapping(this.bmbrandmapping)
    //             .subscribe((resdata : any) => {
    //               if (resdata.status == true) {
    //                 this.toastr.error('Brand Mapping have been Configured.', 'Close', 'green-snackbar');
    //                   this.loader = 'none';
    //                   this.getBrandList();
    //                   this.bmbrandmapping = [];
    //               }
    //               else {
    //                 this.toastr.error(resdata.msg,'Close', 'red-snackbar');
    //                 this.loader = 'none';
    //               }
    //             });
    //           }

    //         }
    //       }
    //     }

  }
  changeif(id: any, IsActive: any) {
    let splitid = id.split('_');
    let brand = splitid[0];
    let brandmanager = splitid[1];
    var List = {
      UserID: brandmanager,
      Brand: brand,
      IsActive: IsActive
    }
    this.bmbrandmapping.push(List);
    this.bmBrandService.updateBmBrandmapping(this.bmbrandmapping)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.toastr.success('Brand Mapping has been Configured.');
          this.getBrandList();
          this.bmbrandmapping = [];
        }
      });

  }


}